import api from 'api';

export const getEngagementTimelineAndPills = async (expression) => {
  try {
    const response = await api.post('hco/qlik/engagement-timeline', {
      expression,
    });

    if (response?.error) {
      throw new Error('API response error');
    }

    return response?.data?.result;
  } catch (error) {
    console.error('Error fetching engagement timeline and pills:', error);
  }
};

export const getEngagementDetails = async (
  filterExpression,
  offset = 0,
  sortBy = 'Date',
  order = 'DESC',
  limit = 5
) => {
  try {
    const response = await api.post('hco/qlik/engagement-table', {
      filterExpression,
      offset,
      limit,
      order,
      sortBy,
    });

    if (response?.error) {
      throw new Error('API response error');
    }

    return response?.data?.result?.data;
  } catch (error) {
    console.error('Error fetching engagement details:', error);
  }
};
